import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
} from "@material-ui/core";
// import { bounce } from "react-animations";
import useStyles from "./styles";
//scss
import "./styles.scss";

import Aos from "aos";
import "aos/dist/aos.css";
// zoom in related

//
const CartItem = ({ item, onUpdateCartQty, onRemoveFromCart }) => {
  const classes = useStyles();
  //
  //--------- pre loader ------
  // const userLink = ["https://stripe.com/docs/testing"];

  const [preloader, setPreloader] = useState(true);
  const [timer, setTimer] = useState(3); //3 secondss

  const id = useRef(null);

  const clear = () => {
    window.clearInterval(id.current);
    setPreloader(false);
  };
  //
  //
  useEffect(() => {
    id.current = window.setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 4000); //4000 is for how long it will stay
  }, [timer]);
  //
  useEffect(() => {
    if (timer === 0) {
      clear();
    }
  }, [timer]);
  //---------------------------
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  // console.log(item);

  return (
    <>
      {/* {preloader ? (
        <div className="absolute-card">
          <br />
          <div className="container-pop">
            <div className="pop">
              <h1>
                Please do not enter a real card number when checking out:{" "}
                <span>Instead, use this dummy Card for testing purposes:</span>
              </h1>
              <h2>4242 4242 4242 4242 </h2>
              <h3>
                read more about dummy cards in the{" "}
                <a rel="noopener noreferrer" target="_blank" href={user}>
                  Stripe official
                </a>{" "}
                page
              </h3>
            </div>
          </div>
        </div>
      ) : (
        ""
      )} */}

      <Card className={classes.cart}>
        <CardMedia
          image={item.image.url}
          alt={item.name}
          className={classes.media}
          data-aos="fade-left"
        />

        {/*  Card Content*/}
        <CardContent className={classes.CartContent}>
          {/* product name, ex: IPHONE */}
          <Typography variant="h6" className={classes.productName}>
            {item.name}
          </Typography>
          {/* 
             price 
          */}
          <Typography variant="h5" className={classes.productPrice}>
            {item.line_total.formatted_with_symbol}
          </Typography>
        </CardContent>
        {/* Car actions */}
        <CardActions className={classes.cartActions}>
          <div className={classes.buttons}>
            <Button
              className={classes.BtnsIncreaseDecrease}
              type="button"
              size="small"
              // ***  1 , because you only want to delete 1 at the same time, not in packs of 3 for example
              onClick={() => onUpdateCartQty(item.id, item.quantity - 1)}
            >
              -
            </Button>

            <Typography>{item.quantity}</Typography>
            {/* 
            
            BUTTON
            
            */}
            <Button
              className={classes.BtnsIncreaseDecrease}
              type="button"
              size="small"
              onClick={() => onUpdateCartQty(item.id, item.quantity + 1)}
            >
              +
            </Button>
          </div>
          {/* This is going to be the item that is going to 
          remove it completely from the card */}
          <Button
            className={classes.buttonRemoves}
            variant="contained"
            type="button"
            onClick={() => onRemoveFromCart(item.id)}
          >
            Removes
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default CartItem;
